export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export function openModal(modalId, props = {}) {
  return {
    type: OPEN_MODAL,
    payload: { modalId, props }
  };
}

export function closeModal() {
  return {
    type: CLOSE_MODAL
  };
}



// WEBPACK FOOTER //
// ./src/actions/modalActions.js